<div class="svg-icon" *ngIf="svg" [innerHTML]="svg"></div>